import { useEffect, useState } from 'react'
import { usePartnerApi } from 'hooks/use-partner-api/usePartnerApi';
import { usePartnerProfile } from 'pages/profile/hooks/usePartnerProfile';
import { AdminsPartnerList } from 'common/types/admin.types';


export const useFetchPartnerAdmins = () => {
  const { fetchPartnerAdminUsersByUserIdAndPartnerId } = usePartnerApi()
  const { company, backendUser } = usePartnerProfile()

  const [partnerAdminList, setPartnerAdminList] = useState<AdminsPartnerList>()
  const [page, setPage] = useState<number>(1)
  const [isLoading, setLoaderStatus] = useState(true)
  const [isFetchingMore, setFetchMoreStatus] = useState(false)

  const getAdminUser = async (page?: number, pageSize?: number) => {
    const admins: AdminsPartnerList = await fetchPartnerAdminUsersByUserIdAndPartnerId(
      backendUser?.id,
      backendUser?.partnerId,
      page
    )

    if (page > 1) {
      setPartnerAdminList({ ...admins, data: [...partnerAdminList?.data, ...admins.data] })

    } else {
      setPartnerAdminList(admins)

    }
  }

  const fetchMore = async (e: any, dataLength: number) => {
    const bottom = e.target.scrollTop
    const totalCount = `${partnerAdminList?.totalCount}`
    if (bottom && !isFetchingMore && parseInt(totalCount || '0') > dataLength) {

      try {
        setFetchMoreStatus(true)
        await getAdminUser(page + 1)
        setPage(page + 1)
        setFetchMoreStatus(false)
        setLoaderStatus(false)
      } catch (error) {
        setFetchMoreStatus(false)
      }
    }
  }

  useEffect(() => {
    getAdminUser()
  }, [])


  return {
    getAdminUser,
    partnerAdminList,
    setPartnerAdminList,
    company,
    page,
    setPage,
    fetchMore,
    isLoading,
    setLoaderStatus,
    isFetchingMore
  } as const
}
